import { isProd } from '../helpers/isProd'

export const SUPPORT_LINK = 'https://support.chessclub.com'
export const IMAGES_CDN_LINK = isProd ? 'https://images.chessclub.com' : 'https://d1svqoq0y28r2z.cloudfront.net'
